import { createI18n } from "vue-i18n";

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("locale") || "en",
  fallbackLocale: "en",
  messages: {},
  globalInjection: true,
  silentTranslationWarn: true,
  silentFallbackWarn: true,
});

const loadedLocales = new Set();

export async function loadLocaleMessages(locale) {
  if (loadedLocales.has(locale)) {
    return;
  }

  try {
    const messages = await import(`@/i18n/locales/${locale}.json`);
    i18n.global.setLocaleMessage(locale, messages.default);
    loadedLocales.add(locale);
  } catch {
    console.warn(`Locale "${locale}" not found, falling back to "en"`);
  }
}

export default i18n;
